import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderRelatedTaxiTaxi from "./billings-order-related-taxi-taxi";
import BillingsOrderRelatedTaxiTaxiParams from "./billings-order-related-taxi-taxi-params";

const useBillingsOrderRelatedTaxiTaxi = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderRelatedTaxiTaxi>({
      data: [],
    });

  const load = async (
    params: BillingsOrderRelatedTaxiTaxiParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const taxiTaxi = await billingService.getOrderRelatedTaxiTaxiBillings(
        params,
        signal,
      );

      setData(taxiTaxi);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsOrderRelatedTaxiTaxi;
